// This is now a pass-thru.  Instead of:
//  import interpolate from 'js-utils/interpolate'
// do:
var interpolate = require('@eb/interpolate-lazy-string')["default"]; // Backwards compatability shim


module.exports = interpolate;